import { render } from "./DeactivatedCollections.vue?vue&type=template&id=69844bd4"
import script from "./DeactivatedCollections.vue?vue&type=script&lang=js"
export * from "./DeactivatedCollections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__